'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { HowList } from '../../components/site/how-list'
import { Reveal } from '../../components/site/reveal'
import { SectionHead } from '../../components/site/section-head'
import { SiteSection } from '../../components/site/section'
import { SubtitleDemo } from './subtitle-demo'
import type { SiteDemoReady } from '@kiao-voice/api-contract/site-demo'

/**
 * 01 · 影片字幕與 Podcast。示範吃滿整欄寬，三條說明放在示範**下方**。
 *
 * `demo` 由 page 在 server 端取好傳進來（見 `site-demo-api.ts`），這一層只負責
 * 往下遞：section 是 client component，自己去抓會替首屏多一個 request。
 */
export function SubtitleDemoSection({ demo }: { demo?: SiteDemoReady | null }) {
  const { t } = useTranslation(['web'])

  return (
    <SiteSection id="uses" trackingKey="subtitle_demo">
      <Reveal>
        <SectionHead
          eyebrow={t('web:transcriptionPage.subtitles.eyebrow')}
          titleKey="web:transcriptionPage.subtitles.title"
          hookKey="web:transcriptionPage.subtitles.hook"
          lead={t('web:transcriptionPage.subtitles.lead')}
        />
      </Reveal>
      <Reveal className="mt-(--gap-xl)">
        <SubtitleDemo demo={demo ?? null} />
      </Reveal>
      <Reveal>
        <HowList
          items={['semantic', 'split', 'export'].map((key) => ({
            title: t(`web:transcriptionPage.subtitles.how.${key}Title`),
            description: t(`web:transcriptionPage.subtitles.how.${key}Desc`),
          }))}
          note={t('web:transcriptionPage.subtitles.how.note')}
        />
      </Reveal>
    </SiteSection>
  )
}
